import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Flag } from '@/components/Flag'

const LANGUAGES = [
	{ code: 'en', name: 'english' },
	{ code: 'fr', name: 'french' },
	{ code: 'de', name: 'german' },
	{ code: 'es', name: 'spanish' },
	{ code: 'zh', name: 'chinese' },
	{ code: 'km', name: 'khmer' },
	{ code: 'vi', name: 'vietnamese' },
]

export function MultiLanguageSupport() {
  const { t, i18n } = useTranslation()
  const fr = i18n.language?.startsWith('fr')
  return (
    <section id="languages" className="fb-section fb-container fb-languages">
      <div className="fb-section-heading">
        <h2>{t('languageTip.title')}</h2>
        <p>{fr
          ? 'Accueillez vos clients dans leur langue. Choisissez la langue du widget lors de son installation.'
          : 'Make customers feel at home. Choose the language of your feedback widget when you install it.'}</p>
      </div>
      <ul className="fb-language-list" aria-label={fr ? 'Langues du widget' : 'Widget languages'}>
        {LANGUAGES.map(language => (
          <li key={language.code}>
            <Flag code={language.code} />
            {t(`languageTip.${language.name}`)}
          </li>
        ))}
      </ul>
      <div className="fb-actions">
        <Link to="/docs" className="fb-text-link">{t('languageTip.seeDocumentation')} <ArrowRight size={16} /></Link>
        <a href="mailto:contact@feedbask.com" className="fb-text-link">{t('languageTip.submitLanguageRequest')} <ArrowRight size={16} /></a>
      </div>
    </section>
  )
}
